import { gql } from '@apollo/client';
import { BULK_REBALANCE_PORTFOLIO_REPORT_FIELDS } from './portfolioReportLookupFields';

export const FETCH_OPTIMIZED_PORTFOLIO_REPORTS = gql`
  query fetchOptimizedPortfolioReports(
    $input: FetchOptimizedPortfolioReportsInput!
  ) {
    fetchOptimizedPortfolioReports(input: $input) {
      portfolioReports {
        ${BULK_REBALANCE_PORTFOLIO_REPORT_FIELDS}
      }
      totalCount
    }
  }
`;
